import type { ComponentChildren } from "preact";
import { IcoLogo } from "../icons";

type AuthLayoutProps = {
  children: ComponentChildren;
  title: string;
  subtitle?: string;
  /** Hide the logo in the header (useful when content has its own visual element) */
  hideLogo?: boolean;
};

export function AuthLayout({
  children,
  title,
  subtitle,
  hideLogo,
}: AuthLayoutProps) {
  return (
    <div
      class="min-h-screen flex flex-col items-center justify-center px-4 py-12 relative overflow-hidden bg-gradient-to-br from-primary-50 via-surface-page to-primary-50/50 dark:from-primary-950/40 dark:via-surface-page dark:to-primary-950/20"
      data-brand="blue"
    >
      {/* Soft radial glow */}
      <div
        class="pointer-events-none absolute inset-0"
        style="background: radial-gradient(ellipse 80% 60% at 50% 30%, oklch(0.93 0.04 250 / 0.35), transparent); "
      />
      <div
        class="pointer-events-none absolute inset-0 dark:hidden"
        style="background: radial-gradient(ellipse 50% 40% at 70% 70%, oklch(0.93 0.04 55 / 0.15), transparent);"
      />

      <div class="w-full max-w-sm relative">
        {/* Logo + heading */}
        <div class="flex flex-col items-center mb-8">
          {!hideLogo && <IcoLogo class="size-10 mb-5" />}
          <h1 class="text-xl font-bold text-text tracking-[-0.01em]">
            {title}
          </h1>
          {subtitle && <p class="text-sm text-text-muted mt-1">{subtitle}</p>}
        </div>

        {/* Card */}
        <div class="rounded-xl border border-border bg-surface p-6 shadow-sm">
          {children}
        </div>
      </div>
    </div>
  );
}
